export default __webpack_public_path__ + "static/media/android.66761269.svg";